
import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "@/hooks/useAuth";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as SonnerToaster } from "@/components/ui/sonner";
import NotFound from "@/pages/NotFound";
import { LoginComponent } from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import JoinComponent from "./pages/join/Join";
import JoinSuccess from "@/pages/join/Success";
import JoinCheckoutSuccess from "@/pages/join/CheckoutSuccess";
import Confirmation from "@/pages/auth/Confirmation";
import Magic from "@/pages/Magic";
import Invited from "@/pages/Invited";

// Dashboard pages
import AuthenticatedLayout from "./pages/dashboard/AuthenticatedLayout";
import DashboardHome from "@/pages/dashboard/Dashboard";
import Products from "@/pages/dashboard/Products";
import Settings from "@/pages/dashboard/Settings";
import Experiments from "@/pages/dashboard/Experiments";
import ExperimentDetail from "@/pages/dashboard/ExperimentDetail";
import Participants from "@/pages/dashboard/Participants";
import ParticipantDetail from "@/pages/dashboard/ParticipantDetail";
import Tastermonials from "@/pages/dashboard/Tastermonials";
import Help from "@/pages/dashboard/Help";
import Billing from "@/pages/dashboard/Billing";

import '@/app.css';
import Organizations from "./pages/dashboard/Organizations";

const queryClient = new QueryClient();

function RootLayout() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <div className="min-h-screen bg-background">
          <Outlet />
          <Toaster />
          <SonnerToaster />
        </div>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default function AppRoutes() {
  return (
    <Routes>
      <Route element={<RootLayout />}>
        {/* Redirect / to /join */}
        <Route path="/" element={<Navigate to="/join" replace />} />

        <Route path="/login" element={<LoginComponent />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/auth/confirmation" element={<Confirmation />} />
        <Route path="/magic" element={<Magic />} />
        <Route path="/invited" element={<Invited />} />

        <Route path="/join">
          <Route index element={<JoinComponent />} />
          <Route path="success" element={<JoinSuccess />} />
          <Route path="checkout-success" element={<JoinCheckoutSuccess />} />
        </Route>

        <Route path="/dashboard" element={<AuthenticatedLayout />}>
          <Route index element={<DashboardHome />} />
          <Route path="products" element={<Products />} />
          <Route path="settings" element={<Settings />} />
          <Route path="experiments" element={<Experiments />} />
          <Route path="experiments/:experimentId" element={<ExperimentDetail />} />
          <Route path="participants" element={<Participants />} />
          <Route path="participants/:userId" element={<ParticipantDetail />} />
          <Route path="tastermonials" element={<Tastermonials />} />
          <Route path="help" element={<Help />} />
          <Route path="billing" element={<Billing />} />
          <Route path="organizations" element={<Organizations />} />
        </Route>

        {/* Catch-all for 404 */}
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
